module.exports = __webpack_public_path__ + "img/page_2.c62cab60.png";